import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';


// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
// import Select from '@material-ui/core/Select';
// import { Card, CardHeader, CardText } from '@material-ui/core/Card';

// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentRemB from '@material-ui/icons/RemoveCircle';
import IconContentReset from '@material-ui/icons/DeleteSweep';

import { Link } from 'react-router-dom';

// Assets imports
import '../styles/NewProject.css';

//Import components
import CustomLoader from './innerComponents/CustomLoader';

const fieldStyle = {
  minHeight: "72px",
  width: "100%",
};

const buttonStyle = {
  marginRight: 12,
};

const cardStyles = {
  marginTop: 10,
  marginLeft: 20,
  marginRight: 20,
  marginBottom: 20,
  supervisors: {
    marginTop: 10,
    marginBottom: 20,
  }
};

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
};


class CreateUser extends Component {

  state = {
    description: '',
    url: '',
    dataSource: [],
    value: 1,
    roleValue: 1
  }



  _rolesItems() {
    return [{ id: "1", text: "Admin", enum: "ADMIN" }, { id: "2", text: "Office Manager", enum: "OFFICE" }
      , { id: "3", text: "Supervisor", enum: "SUPERVISOR" }, { id: "4", text: "Operative", enum: "OPERATIVE" }
      , { id: "5", text: "Contracts Manager", enum: "CONTRACTS" }, { id: "6", text: "Site Manager", enum: "SITE" }]
      .map((item, id) => (
        <MenuItem
          value={item.enum}
          key={item.enum}
        >{item.text}</MenuItem>
      ));
  }

  _regionsItems(items) {
    return items.map((item, id) => (
      <MenuItem
        value={item.id}
        key={item.id}

      >{item.name}</MenuItem>
    ));
  }

  _createUser = async values => {
    // console.log(JSON.stringify(values))
    // name: $name, lastName: $lastName, role:  $role, email: $email, jobTitle: $jobTitle, regionId: $regionId, company: $company, active: $active, password: $password, passwordConfirmation: $passwordConfirmation

    const name = values.userName
    const lastName = values.UserLastName
    const role = values.role
    const email = values.userEmail.toLowerCase()
    const jobTitle = values.jobTitle
    const regionId = values.regionId
    const company = values.company
    // const active = true
    const password = values.password
    const passwordConfirmation = values.passwordConfirmation
    const getWeeklyEmail = (typeof (values.getWeeklyEmail) === 'undefined') ? false : values.getWeeklyEmail

    await this.props.postMutation({
      variables: {
        name,
        lastName,
        email,
        role,
        jobTitle,
        regionId,
        company,
        password,
        passwordConfirmation,
        getWeeklyEmail,
      }
    }).then(({ data }) => {
      alert("User '" + data.createUser.fullName + "' has been created successfully.", data)
      this.props.history.push("/users/list");
    }).catch((error) => {
      var error_text = "";
      error.graphQLErrors.map((item) => (error_text = error_text + "- " + item.message + "\n"))
      alert(error_text)
      console.log('there was an error sending the mutation', error);
    });
  }


  render() {

    const required = value => (value ? undefined : 'Required field');

    const TextFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    // Check if the query response is being loaded
    if (this.props.all_regions_query && this.props.all_regions_query.loading) {
      return <CustomLoader label={'Loading Regions'} />
    }

    // Check if there were errrors
    if (this.props.all_regions_query && this.props.all_regions_query.error) {
      return <div> Regions Could not be loaded </div>
    }


    // Get the data to render it
    const all_regions = this.props.all_regions_query.regions;

    return (
      <Paper style={paperStyle} elevation={1} >
        <div>
          <Form
            onSubmit={this._createUser}
            mutators={{
              ...arrayMutators
            }}
            initialValues={{ supervisors: [] }}
            render={({ handleSubmit, mutators: { push, pop }, reset, submitting, pristine, values }) => (

              <form onSubmit={handleSubmit}>
                <div className="NewProject-header">
                  <div className="NewProject-title">
                    <span>Create User</span>
                  </div>

                  <div className="NewProject-actions">
                    <Button
                      label=""
                      color="primary"
                      component={Link}
                      to="/users/list"
                    ><IconContentRemB />Cancel</Button>
                  </div>
                </div>
                <div className="NewProject-content" style={cardStyles}>

                  Basic Information
                  <br />
                  <br />
                  <div>
                    <Field
                      name="userName"
                      validate={required}
                      component={TextFieldAdapter}
                      label="User Name"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="UserLastName"
                      validate={required}
                      component={TextFieldAdapter}
                      label="User Lastname"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="userEmail"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Email"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="role"
                      select
                      validate={required}
                      component={TextFieldAdapter}
                      value={this.state.roleValue}
                      label="User Role"
                      style={fieldStyle} >
                      {this._rolesItems()}
                    </Field>
                  </div>
                  <div>
                    <Field
                      name="jobTitle"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Bossman, Supervisor, Operative..."
                      label="Job Title"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="company"
                      validate={required}
                      component={TextFieldAdapter}
                      label="Company"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="regionId"
                      select
                      validate={required}
                      component={TextFieldAdapter}
                      value={this.state.value}
                      label="Region"
                      style={fieldStyle} >
                      {this._regionsItems(all_regions)}
                    </Field>
                  </div>
                  <div>
                    <Field
                      name="password"
                      type="password"
                      validate={required}
                      component={TextFieldAdapter}
                      label="Password"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="passwordConfirmation"
                      type="password"
                      validate={required}
                      component={TextFieldAdapter}
                      label="Password Confirmation"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <label>Subscribe to Regions Weekly Email ?</label>
                    <Field
                      name="getWeeklyEmail"
                      component="input"
                      type="checkbox"
                      disabled={localStorage.getItem("current_user_role") !== 'Admin'}
                    />
                  </div>
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </div>
                <div className="NewProject-detailFooter">
                  <div className="buttons">
                    <Button variant="contained"
                      type="submit"
                      color="primary"
                      style={buttonStyle}
                      disabled={submitting || pristine}
                    ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>
                    <Button variant="contained"
                      type="button"
                      color="secondary"
                      style={buttonStyle}
                      onClick={reset}
                      disabled={submitting || pristine}
                    ><IconContentReset style={{ marginRight: 8 }} />Reset</Button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </Paper>

    );
  }
}
// {name: "Camilo" lastName: "Lopez" role:OPERATIVE email:"camilo.lopez@codescrum.com" jobTitle:"The super operative" regionId: 1 company:"Codescrum" active: true password:"qwertyu" passwordConfirmation: "qwertyu", getWeeklyEmail: true or false}
const submitUser = gql`
  mutation createUser($name: String!, $lastName: String!, $role: String!, $email: String!, $jobTitle: String!, $regionId: ID!, $company: String!, $password: String!, $passwordConfirmation: String!, $getWeeklyEmail: Boolean!) {
    createUser(input: {name: $name, lastName: $lastName, email: $email, role: $role, jobTitle: $jobTitle, regionId: $regionId, company: $company, password: $password, passwordConfirmation: $passwordConfirmation, getWeeklyEmail: $getWeeklyEmail}) {
      id
      name
      fullName
    }
  }
`;



const ALL_REGIONS_QUERY = gql`
  query {
    regions {
      id
      name
    }

  }
`;


// const ProfileWithData = graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' })(NewProjectForm);
export default compose(
  graphql(submitUser, { name: 'postMutation' }),
  graphql(ALL_REGIONS_QUERY, {
    name: 'all_regions_query',
    options: {
      refetchQueries: ["all_users_query", "user_query"]
    }
  })
)(CreateUser);


// WEBPACK FOOTER //
// src/components/CreateUser.js